import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import withAccountFormStepStyles from 'Components/UI/Accounts/AccountApplication/Step/withAccountFormStepStyles';
import PhoneNumberField from 'Components/UI/Accounts/AccountApplication/Step/Fields/PhoneNumberField';
import SocialSecurityField from 'Components/UI/Accounts/AccountApplication/Step/Fields/SocialSecurityField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import ScrollIntoView from 'Components/UI/ScrollIntoView';


function BeneficiaryLayout({
  classes,
  onOrganizationUpdate,
  onRelationshipTypeUpdate,
}) {
  const { getError, resource, errors } = useMetaLayoutContext();
  const isOrganization = resource.attr('isOrganization') === 'true' || resource.attr('isOrganization') === true;
  const hasErrors = errors.length > 0;
  function LastNameHelper() {
    if (isOrganization && getError('lastName')) {
      return 'Organization/Trust/Charity name is invalid';
    }
    if (!isOrganization && getError('lastName')) {
      return getError('lastName').shortDetail;
    }
    return null;
  }
  return (
    <div className={classes.root}>
      <div className={classes.row}>
        <MetaField
          attr="isOrganization"
          onChange={onOrganizationUpdate}
        />
      </div>
      <div className={classes.row}>
        <Typography
          variant="h4"
          color="primary"
          className={classes.header}
        >
          {'Contact Information'}
        </Typography>
      </div>
      <div className={classes.row}>
        <MetaField attr="firstName" />
        <MetaField attr="lastName" helperText={LastNameHelper()} />
      </div>
      <div className={classes.row}>
        <PhoneNumberField attr="phoneNumber" />
      </div>
      <div className={classes.row}>
        <Typography
          variant="h4"
          color="primary"
          className={classes.header}
        >
          {'Other Beneficiary Information'}
        </Typography>
      </div>
      <div className={classes.row}>
        <MetaField
          attr="sharePercentage"
        />
        <MetaField attr="beneficiaryType" />
      </div>
      <div className={classes.row}>
        <MetaField
          attr="relationshipType"
          onChange={onRelationshipTypeUpdate}
        />
      </div>
      <div className={classes.row}>
        <MetaField attr="relationship" />
      </div>
      <div className={classes.row}>
        <MetaField attr="birthDate" openTo="year" />
        <SocialSecurityField attr="socialSecurityNumber" />
      </div>
      {hasErrors && <ScrollIntoView />}
    </div>
  );
}

BeneficiaryLayout.propTypes = {
  classes: PropTypes.object.isRequired,
  onOrganizationUpdate: PropTypes.func.isRequired,
  onRelationshipTypeUpdate: PropTypes.func.isRequired,
};

export default withAccountFormStepStyles(BeneficiaryLayout);
